import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'cookie-description',
	templateUrl: './cookie-description.component.html',
	imports: [TranslatePipe],
})
export class CookieDescriptionComponent {}
